<div class="d-sm-flex align-items-center justify-content-between mb-4">
  <h1 class="h3 mb-0 text-gray-800">Realizar Ingreso</h1>
  <a href="#" class="d-none d-sm-inline-block btn btn-sm btn-primary shadow-sm"><i
      class="fas fa-download fa-sm text-white-50"></i> Generate Report</a>
</div>

<div class="row">
  <div class="col-sm-6">


    <div class="card shadow mb-4">
      <div class="card-header py-3">
        <div class="d-flex flex-row justify-content-between">
          <h4 class="m-0 font-weight-bold text-primary">Fichas Deudoras</h4>
          <input type="text" class="form-control" placeholder="Nombre Fantasia" aria-label="Username"
            aria-describedby="basic-addon1" name="name" [(ngModel)]="name" (change)="search($event.target.value)"
            style="max-width: 300px;">
        </div>
      </div>
      <div class="card-body">
        <table class="table">
          <thead>
            <tr>
              <th scope="col">#</th>
              <th scope="col">Ficha</th>
              <th scope="col">Telefono</th>
              <th scope="col">Monto</th>
              <th scope="col">Acciones</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of pending_users ;index as i">
              <th scope="row">{{i+1}}</th>
              <td>{{item.user?.fakeData?.username}}</td>
              <td>{{item.user?.fakeData?.whatsapp}}</td>
              <td>{{item.pending | currency:'ARS':'symbol':'1.0'}}</td>
              <td>
                <div class="btn-group">
                  <button type="button" class="btn btn-success btn-sm" (click)="set(item)">
                    <i class="fas fa-arrow-circle-right"></i>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>

      </div>
    </div>


  </div>
  <div class="col-sm-6" >
    <div class="card" *ngIf="item.user">
      <div class="card-header py-3">
        <div class="d-flex flex-row ">
          <h4 class="m-0 font-weight-bold text-primary">Datos del Ingreso</h4>
        </div>
      </div>
      <div class="card-body">
        <h5 class="text-muted">Nombre de Fantasia :</h5>
        <h4 class="card-title text-dark">{{item?.user.fakeData?.username}}</h4>

        <app-input [user]="item.user._id" [admin]="admin._id" [profile]="item.profile"></app-input>
      </div>

    </div>




  </div>

</div>
